import { AppLayout } from 'layouts';
import { DefaultChatroom } from 'features/chat';
import { useChatroomsSearchParams, useNavigateToChatroom, useNavigateToCreateChat } from '../hooks';

const PageChatrooms = () => {
  const navigateToChatroom = useNavigateToChatroom();
  const navigateToCreateChat = useNavigateToCreateChat();
  const searchParamsOptions = useChatroomsSearchParams();

  return (
    <AppLayout fitCenterContent>
      <DefaultChatroom
        onCreateChatClicked={navigateToCreateChat}
        redirectToChatroom={navigateToChatroom}
        searchParamsOptions={searchParamsOptions}
      />
    </AppLayout>
  );
};

export default PageChatrooms;
